import React, { Component } from 'react';
import { ProgressIndicator } from 'office-ui-fabric-react';
import Plot from 'react-plotly.js';
import { buildChartData } from '../utilities';
import _ from 'underscore';

class Chart extends Component {


  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.columnWidth !== this.props.columnWidth) return true
    if(nextProps.plot.showPanel !== this.props.plot.showPanel) return true
    if(nextProps.plot.isLoading !== this.props.plot.isLoading) return true
    if(nextProps.plot.layout.showlegend !== this.props.plot.layout.showlegend) return true
    if(nextProps.plot.layout.yaxis.fixedrange !== this.props.plot.layout.yaxis.fixedrange) return true
    if(nextProps.plot.useDatum !== this.props.plot.useDatum) return true
    if(!_.isEqual(nextProps.plot.thresholds, this.props.plot.thresholds)) return true
    if(_.isEqual(nextProps.plot.data, this.props.plot.data)) return false
    // if(this.state.date_format === nextState.date_format) return false
    else return true;
  };

  render(){
    // const { plot, editChartLayout, plotIndex } = this.props;
    const { plot } = this.props;
    let { data, layout, config, thresholds, stages, isLoading } = plot;
    let hasData = (data && data.length) || (thresholds && thresholds.length);
    
    // if we dont have data, and we are not attemplting to load data, show a message
    if(!plot || !hasData){
      return (
        <div className='default-shadow chart' style={{display: 'flex', flex: '1', background: '#fff', justifyContent: 'center', alignItems: 'center'}}>
          {
            !isLoading ? (<p>No data to display.</p>) : (<ProgressIndicator className='loader'/>)
          }
        </div>
      )
    } else {
      if(plot.appliedFilters && (plot.appliedFilters.method === 'Multiple Alternative')){
        layout = {
          ...layout,
          xaxis: {
            ...layout.xaxis,
            tickformat: '%b-%e',
            // tickmode: 'auto',
            nticks: 12
          },
          yaxis: {
            ...layout.yaxis,
            range: plot.useDatum ? [parseFloat(layout.yaxis.range[0] - parseFloat(plot.datum)), parseFloat(layout.yaxis.range[1] - parseFloat(plot.datum))] : layout.yaxis.range
          }
        }
      } else if(plot.appliedFilters.method === 'Time Series') {
        layout = {
          ...layout,
          xaxis: {
            ...layout.xaxis,
            tickformat: '%b-%Y'
          },
          yaxis: {
            ...layout.yaxis,
            range: plot.useDatum ? [parseFloat(layout.yaxis.range[0] - parseFloat(plot.datum)), parseFloat(layout.yaxis.range[1] - parseFloat(plot.datum))] : layout.yaxis.range
          }
        }
      } else {
        // its stat year
        layout = {
          ...layout,
          hovermode: 'closest',
          xaxis: {
            ...layout.xaxis,
            tickformat: '%b-%e',
            // tickmode: 'auto',
            nticks: 12,
          },
          yaxis: {
            ...layout.yaxis,
            range: plot.useDatum ? [parseFloat(layout.yaxis.range[0] - parseFloat(plot.datum)), parseFloat(layout.yaxis.range[1] - parseFloat(plot.datum))] : layout.yaxis.range
          }
        }
      };
      
      let chartData = buildChartData(data, thresholds, stages, plot.datum, plot.useDatum); // combines the data & thresholds

      return (
        <div className='default-shadow chart' style={{background: '#fff', position: 'relative'}}>
          <ProgressIndicator className={!isLoading ? 'loader hidden' : 'loader'}/>
          <Plot
            ref={plotlyRef => {
              this.plotlyRef = plotlyRef;
            }}
            className='plotly-plot'
            useResizeHandler={true}
            data={ chartData }
            layout={ {
              ...layout,
              hovermode: 'closest',
              hoverlabel: {
                bgcolor: '#666666'
              },
              xaxis: {
                ...layout.xaxis,
                automargin: true
              }
            } }
            config={{
              ...config,
              displaylogo: false,
              modeBarButtonsToRemove: ['toImage']
            }}
          />
          <p className='disclaimer'>This version of the HydroViz tool displays the hydrological results of prescriptive modeling the draft Fort Peck Test Release DEIS alternatives over the period of record.  Sharing this tool is intended to facilitate understanding of the alternatives' potential effects in comparison to the existing operation of the system (No Action alternative) and to enable an open, transparent, collaborative discussion among stakeholders. These alternatives represent a range of actions that are being evaluated as part of the NEPA process but it is understood that the agency has not selected any of the potential alternatives. Additionally, potential alternatives may be revised following coordination of the draft EIS with the public, Tribes, agencies, and other stakeholders. These alternatives do not reflect any past, present, or actual operation of the system.  Manipulation of the underlying modeling results would invalidate the depiction of the alternatives' effects.</p>
        </div>
      )
    }
  } 
};

export default Chart;


// WEBPACK FOOTER //
// ./src/components/chart.js